import React from 'react';
import PropTypes from 'prop-types';
import {Box, Button, CircularProgress} from '@mui/material';
import {useTheme} from '@mui/material/styles';
import {Refresh} from '@mui/icons-material';
import SoftBox from "../../components/SoftBox";
import SoftTypography from "../../components/SoftTypography";

const MaintenancePage = ({onRetry, isLoading = false}) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                backgroundColor: theme.palette.grey[100],
                padding: 3
            }}
        >
            <SoftBox
                sx={{
                    maxWidth: 600,
                    textAlign: 'center',
                    backgroundColor: 'white',
                    borderRadius: 2,
                    padding: 4,
                    boxShadow: 3
                }}
            >
                <Box sx={{mb: 3}}>
                    <CircularProgress
                        size={60}
                        sx={{color: 'primary.main', mb: 2}}
                    />
                </Box>

                <SoftTypography variant="h3" color="primary" fontWeight="bold" gutterBottom>
                    Application Under Maintenance
                </SoftTypography>

                <SoftTypography variant="h6" color="text.secondary" sx={{mb: 3}}>
                    We&apos;re currently experiencing technical difficulties
                </SoftTypography>

                <SoftTypography variant="body1" color="text.secondary" sx={{mb: 4}}>
                    Our servers are temporarily unavailable. We&apos;re working to resolve this issue as quickly as
                    possible.
                    Please try again in a few moments.
                </SoftTypography>

                <Box sx={{display: 'flex', gap: 2, justifyContent: 'center'}}>
                    <Button
                        variant="contained"
                        startIcon={<Refresh/>}
                        onClick={onRetry}
                        disabled={isLoading}
                        sx={{minWidth: 120}}
                    >
                        {isLoading ? 'Checking...' : 'Retry'}
                    </Button>
                </Box>

                <SoftTypography variant="body2" color="text.secondary" sx={{mt: 3}}>
                    If the problem persists, please contact support
                </SoftTypography>
            </SoftBox>
        </Box>
    );
};

MaintenancePage.propTypes = {
    onRetry: PropTypes.func.isRequired,
    isLoading: PropTypes.bool
};

export default MaintenancePage; 